module.exports = __webpack_public_path__ + "img/antrian.4340851c.png";